var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FontAwesomeIcon',{staticClass:"cursor-pointer",attrs:{"title":_vm.title,"icon":['far', 'copy']},on:{"click":function($event){return _vm.copy(_vm.text, _vm.message)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }